import Socket from "./Socket";
import Logger from "../../../../utils/Logger";

/**
 * Socket for upload task
 */
export default class SocketUpload extends Socket {

    /**
     *
     * @param {string} url full to call mScore post
     * @param {Uint8Array | null} data to send
     */
    constructor(url, data) {
        super(url);
        this.data = data;
    }

    stop() {
        Logger.log("Aborting socket");
        this.httpRequest.abort();
    }

    runInternal(httpRequest, resolve) {
        Logger.log("POST " + this.url);



        httpRequest.open("POST", this.url, true);

        //httpRequest.setRequestHeader('Access-Control-Request-Method', 'POST');
        //httpRequest.setRequestHeader('Access-Control-Request-Headers', 'X-Requested-With');

        let data = new Blob([this.data], {type: 'text/plain'});
        Logger.log('Blob length : ' + data.size);

        httpRequest.addEventListener("load", (load) => {
            Logger.log(load);
            this.httpStatus  = this.httpRequest.status;
            resolve();
        }, false);
        httpRequest.addEventListener("error", () => {
            Logger.log('error');
            this.httpStatus  = this.httpRequest.status;
            this.hasFailed = true;
            resolve();
        }, false);
        httpRequest.addEventListener("abort", () => {
            Logger.log('abort');
            resolve();
        }, false);
        httpRequest.addEventListener("onabort", () => {
            Logger.log('onabort');
            resolve();
        }, false);
        httpRequest.addEventListener("loadend", () => {
            Logger.log('loadend');
            this.httpStatus  = this.httpRequest.status;
            resolve();
        }, false);
        httpRequest.addEventListener("readystatechange", () => {
            Logger.log('onreadystatechange');
            Logger.log(httpRequest);
        }, false);
        httpRequest.upload.addEventListener("progress", (evt) => {
            this.volume = evt.loaded;
        }, false);
        httpRequest.send(
            data
        );
    }
}


// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/socket/SocketUpload.js